import injectedModule from '@web3-onboard/injected-wallets';
import metamaskModule from '@web3-onboard/metamask';
import coinbaseModule from '@web3-onboard/coinbase';
import walletConnectModule from '@web3-onboard/walletconnect';
import trustModule from '@web3-onboard/trust';
import { AppHostURL, DEFAULT_CHAIN, SupportChains } from '@/config';
const injected = injectedModule({});
const metamask = metamaskModule({
    options: {
        extensionOnly: false,
        i18nOptions: {
            enabled: true,
        },
        dappMetadata: {
            name: 'Aicade Galaxy',
        },
    },
});
const coinbase = coinbaseModule();
const supportChainIds = SupportChains.map((chain) => chain.chainId);
const walletConnect = walletConnectModule({
    projectId: 'f6bd6e2911b56f5ac3bc8b2d0e2d7ad5',
    requiredChains: DEFAULT_CHAIN ? [DEFAULT_CHAIN.chainId] : supportChainIds.slice(0, 1),
    optionalChains: supportChainIds,
    dappUrl: AppHostURL,
});
const trust = trustModule();
const walletList = [injected, metamask, coinbase, walletConnect, trust];

export default walletList;
